import { useAuth0, User } from "@auth0/auth0-react";
import { useEffect } from "react";
// import { useCookies } from "react-cookie";

import { auth0ExpirationDate } from "../utils/auth0";
// import { sendEmailEvents } from "../utils/email";
import { useQueryParam } from "../utils/url";
import LoadingSpinner from "./LoadingSpinner";

const getCookie = (name: string): string | undefined => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift();
  return undefined;
};

const RedirectLoader = () => {
  // const [cookies, setCookies] = useCookies(["PLATEAUSER"]);
  const { user } = useAuth0<User>();
  const returnTo = useQueryParam("returnTo") ?? "/app/profile/";
  const source = useQueryParam("src");

  // useEffect(() => {
  //   // setCookies("PLATEAUSER", user, {
  //   //   path: "/",
  //   //   expires: auth0ExpirationDate,
  //   // });

  //   if (user) {
  //     const expires = auth0ExpirationDate.toUTCString();
  //     document.cookie = `PLATEAUSER=${encodeURIComponent(JSON.stringify(user))}; path=/; expires=${expires}`;
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    if ((source === "login" || source === "signUp") && user && user.email) {
      // sendEmailEvents({ email: user?.email, name: user?.name });
      // window.cohesion("tagular:eventCompleted", (payload) => {
      //   if (payload.event === "core.Identify.v1") {
      //     window.location.replace(`${window.location.origin}${returnTo}`);
      //   }
      // });
      // TODO:

      const storedUserCookie = getCookie("PLATEAUSER");
      if (storedUserCookie) {
        const storedUser = JSON.parse(decodeURIComponent(storedUserCookie));
        console.log("Stored User:", storedUser);
      } else {
        console.log("No PLATEAUSER cookie found");
        const expires = auth0ExpirationDate.toUTCString();
        document.cookie = `PLATEAUSER=${encodeURIComponent(JSON.stringify(user))}; path=/; expires=${expires}`;
      }
      console.log("source is loading");
      console.log("SHOULD BE SENDING EMAIL EVENTS");
    } else {
      window.location.replace(`${window.location.origin}${returnTo}`);
    }
    // eslint-next-line react-hooks/exhaustive-deps
  }, [returnTo, source, user]);

  return <LoadingSpinner />;
};

export default RedirectLoader;
